import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "animated-emojis"
    }}>{`Animated Emojis`}</h1>
    <p>{`Library with animated emojis.`}</p>
    <p><img alt="gif" src={require("./assets/e.gif")} /></p>
    <h2 {...{
      "id": "docs"
    }}>{`Docs`}</h2>
    <p><a parentName="p" {...{
        "href": "https://animated-emojis.netlify.com/"
      }}>{`https://animated-emojis.netlify.com/`}</a></p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`yarn add animated-emojis # npm i animated-emojis
`}</code></pre>
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <pre><code parentName="pre" {...{}}>{`size: Number | undefined
animate: Boolean | undefined
`}</code></pre>
    <h2 {...{
      "id": "setup"
    }}>{`Setup`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`yarn # npm i
`}</code></pre>
    <h2 {...{
      "id": "run-docs"
    }}>{`Run docs`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`yarn docz:dev # npm run docz:dev
`}</code></pre>
    <h2 {...{
      "id": "build-lib"
    }}>{`Build lib`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`yarn build # npm run build
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      